import type { PaymentOption } from '@src/domains/payments/types/payment';

const UPFRONT_DIVISION = 1;

export const resolveDefaultInstallmentDivision = (paymentOption: PaymentOption | undefined): number => {
  const installmentOptions = paymentOption?.installmentOptions ?? [];

  if (installmentOptions.length === 0) {
    return UPFRONT_DIVISION;
  }

  return Math.min(...installmentOptions.map((option) => option.division));
};
